<template>
  <div>
    <div class="text-center">
      <b-button
        class="loadable-button"
        @click="addToCart()"
        native-type="button"
        rounded
      >
        {{ $t("addToCart") }}
      </b-button>
    </div>
    <b-modal v-model="addedToCardModal" :width="350" @close="closeAddModal">
      <div class="card">
        <div class="card-content p-4">
          <p class="title is-5">
            {{ $t("addOnMyCart") }}
          </p>
          <div class="content">
            <!-- For add to basket -->
            <div v-if="!addedToCard">
              <div class="columns is-vcentered is-mobile mb-0">
                <div class="column pr-0" style="max-width: 95px;">
                  <strong>{{ $t("quantity") }} :</strong>
                </div>
                <div class="column">
                  <b-field>
                    <b-select expanded v-model="quantity">
                      <option
                        v-for="(index, quantityIndex) in quantityMax"
                        :key="`quantity-${quantityIndex}`"
                      >
                        {{ index }}
                      </option>
                    </b-select>
                  </b-field>
                </div>
              </div>
              <b-button
                expanded
                rounded
                :loading="loading"
                class="button button-cart is-primary add-cart-button"
                :title="$t('addToCart')"
                icon-left="cart-arrow-down"
                style="font-size: 1em"
                @click="submit()"
              >
                {{ $t("addToCart") }}
              </b-button>
            </div>

            <!-- success add to card -->
            <div v-if="addedToCard">
              <div class="message is-success mt-2 mb-2">
                <div class="message-body">
                  <b-icon icon="cart-plus" class="has-text-success mr-1" />
                  {{ $tc("successToAdded", quantityAdded, { count: quantityAdded }) }} {{ $t("cart") }}
                </div>
              </div>
              <div class="columns is-mobile">
                <div class="column">
                  <b-button
                    expanded
                    rounded
                    @click="closeAddModal"
                  >
                    {{ $t("continueShopping") }}
                  </b-button>
                </div>
                <div class="column pl-0">
                  <a
                    class="button is-fullwidth is-rounded is-primary"
                    :href="osvConfig.paths.cartProduct"
                  >
                    {{ $t("myCart") }}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { LocaleMixin } from "@/mixins/LocaleMixin";
import { ConfigMixin } from "@/mixins/ConfigMixin";
import VueI18n from "vue-i18n";

export default {
  name: "AddProductToCardModal",
  mixins: [LocaleMixin, ConfigMixin],
  props: {
    addToCardCallback: {
      type: Function,
      required: true
    },
    quantityMax: {
      type: Number,
      default: 5
    }
  },

  data() {
    return {
      addedToCardModal: false,
      addedToCard: false,
      quantity: 1,
      quantityAdded: 0,
      loading: false
    };
  },

  methods: {
    addToCart() {
      this.addedToCardModal = true;
    },

    closeAddModal() {
      this.quantity = 1;
      this.addedToCard = false;
      this.addedToCardModal = false;
    },

    submit() {
      this.quantityAdded = this.quantity;
      this.addToCardCallback(this.quantity);
      this.loading = true;
    },

    success(goToCard = false) {
      if (goToCard) {
        location.href = this.osvConfig.paths.cartProduct
      } else {
        this.addedToCard = true;
        this.loading = false;
      }
    },

    failed() {
      this.loading = false;
    }
  },

  // Translate component
  mounted() {
    this.$i18n.locale = this.getLocale();
  },
  i18n: new VueI18n({
    locale: "fr",
    messages: {
      en: {
        addToCart: "Add to cart",
        successToAdded: "Add to",
        quantity: "Quantity",
        cart: "cart",
        myCart: "My cart",
        continueShopping: "Continue shopping",
        addOnMyCart: "Add on my cart"
      },
      fr: {
        addToCart: "Ajouter au panier",
        successToAdded: "Ajouté au",
        quantity: "Quantité",
        cart: "panier",
        myCart: "Mon panier",
        continueShopping: "Continuer mes achats",
        addOnMyCart: "Ajouter à mon panier"
      }
    }
  })
};
</script>
